/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {useState, useEffect} from 'react'
import {Link} from 'react-router'
import {toAbsoluteUrl} from '../../../helpers'
import {IHeader, useLayout} from '../../core'
import {AsideVisibilityToggle} from '../aside/AsideVisibilityToggle'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'

type HeaderWrapperProps = {
  forceAsideHidden?: boolean
}

const calculateStickyOffset = (header: IHeader): string => {
  if (header.fixed.desktop && header.fixed.tabletAndMobile) {
    return '{default: "200px", lg: "300px"}'
  }

  if (header.fixed.desktop && !header.fixed.tabletAndMobile) {
    return '{lg: "300px"}'
  }

  if (header.fixed.tabletAndMobile && !header.fixed.desktop) {
    return '{default: "200px", lg: false}'
  }

  return ''
}

const calculateShowSticky = (header: IHeader): boolean => {
  return (
    (header.fixed.desktop && header.fixed.tabletAndMobile) ||
    (header.fixed.desktop && !header.fixed.tabletAndMobile) ||
    (header.fixed.tabletAndMobile && !header.fixed.desktop)
  )
}

export function HeaderWrapper({forceAsideHidden = false}: HeaderWrapperProps) {
  const {config, classes, attributes} = useLayout()
  const {header} = config
  const [stickyOffset, setStickyOffset] = useState<string>(calculateStickyOffset(header))
  const [showSticky, setShowSticky] = useState<boolean>(calculateShowSticky(header))

  useEffect(() => {
    setStickyOffset(calculateStickyOffset(header))
    setShowSticky(calculateShowSticky(header))
  }, [header])

  return (
    <>
      <div
        id='kt_header'
        className={clsx('header', classes.header.join(' '))}
        {...attributes.headerMenu}
        data-kt-sticky={showSticky ? 'true' : 'false'}
        data-kt-sticky-name='header'
        data-kt-sticky-offset={stickyOffset}
      >
        <div
          className={clsx(classes.headerContainer.join(' '), 'd-flex flex-stack flex-wrap gap-2')}
          id='kt_header_container'
        >
          <DefaultTitle />

          {/* begin::Wrapper */}
          <div className='d-flex align-items-center ms-n2 me-2'>
            {/* begin::Aside mobile toggle */}
            <AsideVisibilityToggle forceHidden={forceAsideHidden} />
            {/* end::Aside mobile toggle */}

            {/* begin::Logo */}

            <Link to='/dashboard' className='d-flex align-items-center d-lg-none'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/gradeurexam2.png')}
                className='h-md-100px h-60px mt-5 mt-md-0'
              />
            </Link>
            {/* end::Logo */}
          </div>
          {/* end::Wrapper */}
          <Topbar />
        </div>
      </div>
    </>
  )
}
